import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IMachineryWithLocation} from "../../../models/iMachinery";

interface IMapState {
    list: IMachineryWithLocation[];
    isLoading: boolean;
    isMapConnected: boolean;
    current: IMachineryWithLocation | null;
    centerCounter: number,
    /** Фильтр панели/карты по типу техники. null = показывать все типы. */
    typeFilter: number | null;
}

const initialState: IMapState = {
    list: [],
    isLoading: false,
    isMapConnected: false,
    current: null,
    centerCounter: 0,
    typeFilter: null,
};

export const MapSlice = createSlice({
    name: "map_slice",
    initialState,
    reducers: {
        setMachineryWithLocation: (state, action: PayloadAction<IMachineryWithLocation[]>) => {
            state.list = action.payload;
            state.isLoading = false;
        },
        setIsMapConnected: (state, action: PayloadAction<boolean>) => {
            state.isMapConnected = action.payload;
        },
        setMapIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateMachineryWithLocation: (state, action: PayloadAction<IMachineryWithLocation>) => {
            state.list = [...state.list.map(machinery => machinery.id === action.payload.id
                ? action.payload
                : machinery)];
        },
        setMapCurrentMachinery: (state, action: PayloadAction<IMachineryWithLocation | null>) => {
            state.current = action.payload;
            state.centerCounter += 1;
        },
        setMapTypeFilter: (state, action: PayloadAction<number | null>) => {
            state.typeFilter = action.payload;
            // Если выбранная машина не проходит новый фильтр — снимаем выбор,
            // иначе подсветка и центрирование указывали бы на скрытый маркер.
            if (
                action.payload != null &&
                state.current != null &&
                state.current.type_id !== action.payload
            ) {
                state.current = null;
            }
        }
    },
});

export const {
    setMachineryWithLocation,
    setIsMapConnected,
    updateMachineryWithLocation,
    setMapIsLoading,
    setMapCurrentMachinery,
    setMapTypeFilter
} = MapSlice.actions;
export default MapSlice.reducer;